import * as React from 'react';
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CardActionArea from "@mui/material/CardActionArea";
import {CardContent, Typography} from "@mui/material";
import {Business, Person} from "@mui/icons-material";
import {Trans} from "react-i18next";
import DataForm from "./DataForm";
import UserInfo, {StyledMuiCard} from "./UserInfo";
import {validateUserInfoItem} from "../../../managers/cartManager/validators/userInfoValidator";
import UserManager from "../../../managers/userManager/userManager";

function InvoiceDataEditor({invoiceData, setInvoiceData, dataFormValidity, setDataFormValidity}) {
    const userInfo = invoiceData.userInfo;
    const personType = invoiceData.type;

    const handlePersonTypeChange = (value) => {
        invoiceData.type = value;
        setInvoiceData({...invoiceData});
    };

    const onDataFormChange = (id, value) => {
        const newUserInfo = Object.assign({}, userInfo);
        setDataFormItemValidity(id, validateUserInfoItem(id, value));
        newUserInfo[id] = value;
        invoiceData.userInfo = newUserInfo;
        setInvoiceData({...invoiceData});
    }

    const onDataFormBlur = (id) => {
        setDataFormItemValidity(id, validateUserInfoItem(id, userInfo[id]));
    }

    const setDataFormItemValidity = (id, error) => {
        const newValidity = Object.assign({}, dataFormValidity);
        newValidity[id] = error;
        setDataFormValidity(newValidity);
    }

    return (
        <Stack spacing={{xs: 3, sm: 6}} useFlexGap>
            <FormControl component="fieldset" fullWidth>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: {xs: 'column', sm: 'row'},
                        gap: 2,
                    }}
                >
                    <StyledMuiCard selected={personType === UserInfo.types.NATURAL_PERSON}>
                        <CardActionArea
                            onClick={() => handlePersonTypeChange(UserInfo.types.NATURAL_PERSON)}
                            sx={{
                                '.MuiCardActionArea-focusHighlight': {
                                    backgroundColor: 'transparent',
                                },
                                '&:focus-visible': {
                                    backgroundColor: 'action.hover',
                                },
                            }}
                        >
                            <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <Person
                                    fontSize="small"
                                    sx={[
                                        (theme) => ({
                                            color: 'grey.400',
                                            ...theme.applyStyles('dark', {
                                                color: 'grey.600',
                                            }),
                                        }),
                                        personType === UserInfo.types.NATURAL_PERSON && {
                                            color: 'primary.main',
                                        },
                                    ]}
                                />
                                <Typography sx={{fontWeight: 'medium'}}><Trans
                                    i18nKey={`invoiceData.${UserInfo.types.NATURAL_PERSON}`}/></Typography>
                            </CardContent>
                        </CardActionArea>
                    </StyledMuiCard>
                    <StyledMuiCard selected={personType === UserInfo.types.JURIDICAL_PERSON}>
                        <CardActionArea
                            onClick={() => handlePersonTypeChange(UserInfo.types.JURIDICAL_PERSON)}
                            sx={{
                                '.MuiCardActionArea-focusHighlight': {
                                    backgroundColor: 'transparent',
                                },
                                '&:focus-visible': {
                                    backgroundColor: 'action.hover',
                                },
                            }}
                        >
                            <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <Business
                                    fontSize="small"
                                    sx={[
                                        (theme) => ({
                                            color: 'grey.400',
                                            ...theme.applyStyles('dark', {
                                                color: 'grey.600',
                                            }),
                                        }),
                                        personType === UserInfo.types.JURIDICAL_PERSON && {
                                            color: 'primary.main',
                                        },
                                    ]}
                                />
                                <Typography sx={{fontWeight: 'medium'}}><Trans
                                    i18nKey={`invoiceData.${UserInfo.types.JURIDICAL_PERSON}`}/></Typography>
                            </CardContent>
                        </CardActionArea>
                    </StyledMuiCard>
                </Box>
            </FormControl>
            <DataForm userInfo={userInfo} onChange={onDataFormChange} validity={dataFormValidity}
                      onBlur={onDataFormBlur} withoutEmail={UserManager.getUser().uid} personType={personType}/>
        </Stack>
    );
}

export default InvoiceDataEditor;